<button
    [id]="'button_attachment-file_Attach'"
    color="secondary"
    mat-stroked-button
    style="height: min-content"
    (click)="download(attachment.nome, attachment.urlAnexo[0])"
>
    <mat-icon color="primary">{{ attachment.nome | filename | materialIcon }}</mat-icon>
    <span class="file-name">{{ attachment.nome | filename }}</span>
</button>
